import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetitionStatusForm from '../../../components/forms/CompetitionStatusForm';
import { useCompetitionStatusApi } from '../../../hooks/useCompetitionStatusApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { CompetitionStatusDTO } from '../../../services/apiClient';

const CompetitionStatusCreate: React.FC = () => {
  const { create, isLoading } = useCompetitionStatusApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competition Statuses', href: '/admin/competitionstatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CompetitionStatusDTO) => {
    try {
      await create(data);
      navigate('/admin/competitionstatuses');
    } catch (error) {
      console.error('Error creating CompetitionStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitionstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.CompetitionStatus.Edit"
    >
        <CompetitionStatusForm
          initialValues={{} as CompetitionStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/competitionstatuses')}
        />
    </AdminLayout>
  );
};

export default CompetitionStatusCreate;
